/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putRecord.defs.js'
export * as $defs from './putRecord.defs.js'
